
import { defineComponent, onMounted, ref } from 'vue'
import {
    useRoute
} from 'vue-router';
import pservice from '@/core/services/PublicService';

export default defineComponent({
    name: "public-goalscorers",
    setup() {
        const route = useRoute();
        const { idevent, idsport } = route.params
        const link = ref<any>(null)

        const getMore = async () => {
            //loading.value = true
            await pservice.more({
                    evento: idevent,
                    sport: idsport
                })
                .then((res) => {
                    //loading.value = false
                    getLink(res.data.event.idevent)
                }).catch(({
                    response
                }) => {
                    //loading.value = false
                })
        }


        const getLink = (ideve) => {
            switch (idsport) {
                case 'futbol-masculino':
                    link.value = `https://winscore.perufedup.com/publico/campeonatos/${ideve}/categorias/5/fechas/?informe=2`
                    break;
                case 'futbol-femenino':
                    link.value = `https://winscore.perufedup.com/publico/campeonatos/${ideve}/categorias/42/fechas/?informe=2`
                    break;
                case 'futsal-damas':
                    link.value = `https://winscore.perufedup.com/publico/campeonatos/${ideve}/categorias/6/fechas/?informe=2`
                    break;
                case 'futsal-varones':
                    link.value = `https://winscore.perufedup.com/publico/campeonatos/${ideve}/categorias/7/fechas/?informe=2`
                    break;
            }
        }

        onMounted(() => {
            //getLink()
            getMore()
        })

        return {
            link,
            getMore

        }

    },
})
